import React, { forwardRef } from 'react';
import { Marker } from 'fronton-react';
import { CheckCircleIcon } from '@fronton/icons-react';

type OriginalProductMarkerProps = {
  text: string;
  color: string;
  onOpen: () => void;
};

const DATA_QA_ORIGINAL_PRODUCT_MARKER = 'original-product-marker';

export const OriginalProductMarker = forwardRef<HTMLDivElement, OriginalProductMarkerProps>(
  ({ text, color, onOpen }, ref) => (
    <Marker
      data-testid={DATA_QA_ORIGINAL_PRODUCT_MARKER}
      background={color}
      charsLimit={30}
      color="text-primary-invert"
      iconLeft={<CheckCircleIcon type="fill" size="l" color="success-light" />}
      onClick={onOpen}
      size="l"
      text={text}
      variant="angular"
      ref={ref}
    />
  ),
);
